import { cn } from "@gymflow/helpers";
import { AlertCircleIcon } from "apps/portal/src/components/atoms";

type InfoBlockProps = {
  text: string;
  className?: string;
};

export const InfoBlock = ({ text, className }: InfoBlockProps) => (
  <div
    className={cn(
      "flex items-start gap-2 rounded-lg bg-gray-100 px-3 py-1.5 dark:bg-gray-800",
      className,
    )}
  >
    <div className="my-1">
      <AlertCircleIcon
        className="size-4"
        pathClassName="stroke-gray-500 dark:stroke-gray-400"
      />
    </div>
    <div className="dark:text-gray-25 text-sm font-medium text-gray-950">
      {text}
    </div>
  </div>
);
